<template>
  <div class="hello">
    <Header></Header>
    <div class="content_s clearfix">
      <el-row>
        <el-col>
          <div class="all-search-input1">
            <!-- <el-autocomplete placeholder="请输入供应商号">  </el-autocomplete> -->
            <input maxlength="20" :class="inpt_search?'inp_s input1_focus':'inp_s'" type="text" placeholder=" 请输入关键词" ref="search_content" v-model="searchKey"  value=""  
            @input="serach_tips()"  
            @focus="input_focus()" 
            @blur="input_blur()" 
            @keyup.enter="searchKeysfnc()"
            @keydown.up="navigateOptions('up')"
            @keydown.down="navigateOptions('down')"
            >
            <button type="button" class="el-button el-button--default" @click="searchKeysfnc()"><span>站内搜索</span></button>
          </div>

        <!-- tips start -->
        <div class="index_input1" v-if="result != '0' ">
          <!-- <span>猜您想搜：</span> -->
          <ul v-if="tips" 
          :v-model="tips"
          >
          <!-- <ul> -->
            <li v-for="(item, index) in result" :key="index" :v-model="result" :class="index == tipsnum?'li_hover':''" @mouseover="mouse_pointer" @mousemove="enent(index)" @mouseleave="leave_mouse">
            <span v-if="item._source.title" @mousedown="redirect_tips(item._source.title)">{{item._source.title}}  </span>
            <span v-if="item._source.author">【{{item._source.author}}】</span>
            <span class="tips_hot" v-if="index == 0">热</span>
            </li>
          </ul>
        </div> 

        
          <div class="listsearch-item">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="文章" name="first">
                <span v-if="isFirst"> 
                <!-- 加载动画 -->
                <el-skeleton style="width: 880px" animated :loading="isLoading">
                  <template slot="template">
                    <div  style="width: 100%;">
                      <div style="width: 30%; float: left;"><el-skeleton-item variant="image" style="width: 261px; height: 174px;" /></div>
                      <div style="width: 60%; float: left; margin-left: 30px;">
                        <el-skeleton-item variant="text" style="width: 80%;" />
                      </div>
                      <div style="width: 60%; float: left; margin-left: 30px;">
                        <el-skeleton-item variant="text" style="width: 20%;" />
                        <el-skeleton-item variant="text" style="width: 15%;" />
                        <el-skeleton-item variant="text" style="width: 15%;" />
                      </div>
                      <div style="width: 60%; float: left;margin-left: 30px;">
                        <el-skeleton-item variant="text" style="width: 80%;" />
                        <el-skeleton-item variant="text" style="width: 80%;" />
                        <el-skeleton-item variant="text" style="width: 80%;" />
                      </div>
                    </div>
                  </template>

                <template>
                   <!-- 显示空数据 -->
                  <div class="listsearch" v-if="searchResultData.length == 0">
                  <el-row>
                    <el-col>  
                      <div class="listsearch-nodata">
                        <el-result icon="info" title="很抱歉，没有找到相关结果" subTitle="请修改或者尝试其他搜索词"></el-result>
                      </div>
                      </el-col>
                  </el-row>
                </div>

                <!-- 显示主题内容 -->
                <div class="listsearch" v-if="searchResultData != 0">
                  <el-row>
                    <div v-show="result_coru">搜到关于 <span style="color:red;">“{{searchKey_set}}”</span> 的相关结果 {{total}} 条，本次搜索共花费 <span style="color:orange;">{{took}}</span> ms</div>
                    <!-- 搜索结果 for -->
                    <el-col v-for="(o, index) in searchResultData" :key="index">
                      <div class="kx-search  clearfix">
                        <div class="video-pic">
                          <img :src="o._source.thumb_image_url" class="img" >
                        </div>
                        <router-link target="_blank" :to="'/article/' + o._source.uniquecode">
                          <span v-if="o.highlight && o.highlight.title">
                            <h3  v-html="o.highlight.title[0]"></h3>
                          </span>
                          <span  v-else>
                            <h3>{{o._source.title}}</h3>
                          </span>
                          <span v-if="o.highlight && o.highlight.author" v-html="o.highlight.author[0]"></span>
                        <span v-else><b>{{o._source.author}}</b></span>
                        <span>发布时间：{{o._source.public_time}}</span>
                        
                        <span v-if="o.highlight.content">
                          <p v-for="(v,k) in o.highlight.content" :key="k" v-html="v"></p>
                        </span>
                          <p v-if="!o.highlight.content">{{o._source.summary}}</p>
                      
                        </router-link>
                       
                      </div>
                    </el-col>
                  </el-row>
                  <div v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
                  <el-button type="primary"
                    @click="openFullScreen_search"
                    v-if="total > 15"
                  >{{downloadMore}}</el-button>
                  </div>
                </div>
                </template>
              </el-skeleton>

              </span>
              </el-tab-pane>

              <el-tab-pane label="杂志" name="second">
                <el-skeleton style="width: 880px" animated :loading="isLoading">
                  <template slot="template">
                    <div  style="width: 100%;">
                      <div style="width: 60%;  margin-left: 30px;">
                        <el-skeleton-item variant="text" style="width: 50%;" />
                      </div>
                      <div style="width: 20%;  margin-left: 30px;">
                        <el-skeleton-item variant="text" style="width: 30%;" />
                      </div>
                      <div style="width: 50%; margin-left: 30px;">
                        <el-skeleton-item variant="text" style="width: 100%;" />
                        <el-skeleton-item variant="text" style="width: 100%;" />
                        <el-skeleton-item variant="text" style="width: 100%;" />
                      </div>
                    </div>
                  </template>


                <template>
                <div v-if="isSecond">
                  <div class="listsearch" v-if="searchResultData.length == 0">
                  <el-row>
                    <el-col>  
                      <div class="listsearch-nodata">
                        <el-result icon="info" title="很抱歉，没有找到相关结果" subTitle="请修改或者尝试其他搜索词"></el-result>
                      </div>
                      </el-col>
                  </el-row>
                </div>

              <div class="listsearch" v-if="searchResultData != 0">
                <el-row>
                  <div v-show="result_coru">搜到关于 <span style="color:red;">“{{searchKey_set}}”</span> 的相关结果 {{total}} 条，本次搜索共花费 <span style="color:orange;">{{took}}</span> ms</div>
                  <el-col v-for="(o, index) in searchResultData" :key="index">
                    <div class="kx-search">
                      <div  v-if=" new Date(o._source.date).getTime() > (new Date().getTime()-60*60*24*365*1000)"  class="read-zhezhao"><p>最近12个月内的期刊内容暂不提供在线浏览，给您带来的不便敬请谅解。</p><i></i></div>
                    <!-- <span>{{ new Date(o._source.date).getTime() }}</span> -->
                    <!-- <span>{{ new Date().getTime()-60*60*24*365*1000 }}</span> -->
                      <router-link target="_blank" :to="'/magartical/' + o._source.uniquecode">
                        <h3 v-if="o.highlight && o.highlight.title" v-html="o.highlight.title[0]"></h3>
                        <h3 v-else>{{o._source.title}}</h3>
                        <p><b>{{o._source.year}}年第{{o._source.issue_number}}期</b>    </p>
                        <p v-if="o.highlight && o.highlight.author" v-html="o.highlight.author[0]"></p>
                        <p v-else>{{o._source.author}}</p>
                        <span v-if="o.highlight">
                          <p v-for="(v,k) in o.highlight.content" :key="k" v-html="v"></p>
                        </span>
                        <p v-if="!o.highlight.content">{{o._source.content}}</p>
                       
                      </router-link>
                    </div>
                  </el-col>
                </el-row>

                  <div v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
                  <el-button type="primary"
                    @click="openFullScreen_search"
                    v-if="total > 15"
                  >{{downloadMore}}</el-button>
                  </div>
                </div>
                </div>
                </template>
              </el-skeleton>
              </el-tab-pane>
              <!-- <el-tab-pane v-for="(au,index) in chanalsData" :key="index" :label="au.name" :name="au.prop_tra">
            </el-tab-pane> -->
          </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <bbottom></bbottom>
  </div>
</template>
<script>
  import Header from "@/components/public/Header.vue"
  import bbottom from "@/components/public/bbottom.vue"
  import {Loading} from "element-ui"
  export default { 
    name: 'Searchresult',
    data() {
      return {
        tipsnum:-1,
        inpt_search:false,
        tips:false,
        nowIndex:'',
        result: [],
        isFirst: true,
        isSecond: false,
        isLoading:true,
        loading:false,
        downloadMore:'加载更多...',
        startNum:0,
        activeName: 'first',
        searchKey:'',  //设置搜索默认值
        searchKey_set:'',
        empty_result:false,
        result_coru:false,
        result_type:'artical',
        total:0,
        took:'',
        // 小栏目频道
        chanalsData: [
          { name: '文章', prop_tra: 'at' },
          // { name: '快讯', prop_tra: '2021' },
          // { name: '视频', prop_tra: '2020' },
          { name: '杂志', prop_tra: 'mg' },
          // { name: '专题', prop_tra: '2018' },
        ],
        //搜索
        searchResultData:[],
        searchType:'at'
      }
    },

    props: {},
    created(){
      if (this.$route.query.q)
      {
        this.searchKey = this.$route.query.q
        // this.setIntLoading()
        this.searchKeysfnc()
      }
    },

    //页面初始化
    computed: {       
    },
    //页面加载后执行方法

    methods: {
      leave_mouse(){
        this.tipsnum = -1
      },
      enent(index){
        this.tipsnum = index
        console.log(index)
      },

      mouse_pointer(){
        this.tipsnum = -1
      },

      navigateOptions(event){
        if(event == 'up'){
          if(this.tipsnum >= 1){
            this.tipsnum--
            this.searchKey = this.result[this.tipsnum]._source.title
          }
        }else if(event == 'down'){
          if(this.tipsnum >=  -1 && this.tipsnum <  this.result.length -1){
            this.tipsnum++
            this.searchKey = this.result[this.tipsnum]._source.title
          }
        }
      },


      search_tips_opration(){
        // 聚焦输入框的时候，没有输入字段，先展示推荐内容
        // this.inputValue == '' ? this.showData = this.recommendedData : ''
        // this.tips = true
        var config = {
            method: 'GET',
            url: '/api/v1/search/tipskey',
            headers: { 
              'Content-Type': 'application/json'
            },
            params: {searchkey:this.searchKey}
          };

          this.$axios(config).then(res=>{
            if(res.data.hits.hits.length <=0){
              this.result = '0'
              // this.inpt_search = false
            }else{
              this.result = res.data.hits.hits
            }
          })
      },

      serach_tips(){
        // this.searchKey.length == 0 ? this.inpt_search = false : this.inpt_search = true
        this.tips = true
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.search_tips_opration()
        }, 150);
      },

      input_focus(){
        this.serach_tips()
      },

      input_blur(){
        this.tips = false
        this.inpt_search = false
      },

      handleClick(v,k){
        if (v.name === 'first') {
          this.isFirst = true
          this.isSecond = false
          this.searchType = 'at'
        } else if (v.name === 'second') {
          this.isFirst = false
          this.isSecond = true
          this.searchType = 'mg'
        }
        this.searchKeysfnc()
      },

      redirect_tips(strings){
        this.tips = false
        this.searchKey = strings
        this.searchKeysfnc()
      },

      searchKeysfnc()
      {
        if( this.searchKey.length <= 0 ){
          this.isLoading = false 
          return false
        }
        this.tips = false
        this.isLoading = true
        //获取当前tab状态
        var searchType = this.searchType || 'at'
        // let loading = null
        // loading = Loading.service({
        //   fullscreen: false,
        //   text: '正在搜索中，请稍后...'
        // })
        // loading.close()

        this.searchResultData = []
        // this.searchType=searchType;
        this.$router.push({path:'/search',query: {q:this.$data.searchKey,startpage:0,tp:searchType}})
        // console.log(searchType)
        //查找页面  参数为空则显示空数据
        var config = {
            method: 'GET',
            url: '/api/v1/search/result',
            headers: { 
                'Content-Type': 'application/json'
            },
            params: {searchkey:this.searchKey,startpage:0,tp:searchType}
          };

          this.$axios(config).then(res=>{
            // console.log( res )
           
            if(res.data.hits.hits.length <=0){
                this.searchResultData = []
                this.result_coru = false
                setTimeout(() => (this.isLoading = false), 2000)
            }else{
              if(res.data.hits.hits.length >0){
                
                this.searchKey_set = this.searchKey
                this.total = res.data.hits.total.value
                this.took = res.data.took

                for(var i=0; i< res.data.hits.hits.length; i++){
                  this.$set(this.searchResultData, i, res.data.hits.hits[i])
                  this.$forceUpdate()   
                }

                this.result_coru = true
                this.downloadMore = '加载更多...'
                // console.log(this.searchResultData)   
                setTimeout(() => (this.isLoading = false), 1000)
                
                
              }
            }
            console.log('请求成功')
            this.startNum = this.startNum + 15
            //更新数据  文章 视频 快讯 杂志 专题
            //title dect time  关键字标红  后台敏感词过滤标志 status_by  sqllite
            this.$nextTick(() => {
                  // 使用this.$nextTick()之后，里面的内容在DOM更新之后执行，所以取到的是msg修改之后的值 '已更新'
            });


          }).catch(error=>{

            console.log(error)
            console.log('请求失败')
          })

        },

      //页面数据加载更多文章
      openFullScreen_search() {
        this.loading = true;
        var config = {
          method: 'GET',
          url: '/api/v1/search/result',
          headers: { 
            'Content-Type': 'application/json'
          },
           params: {searchkey:this.searchKey,startpage:this.startNum+1,tp:this.searchType}
        };
        
        var artical_length = this.searchResultData.length
        this.$axios(config).then(res=>{
          
          setTimeout(() => {
            if(res.data.hits.hits.length > 0){
              for(var i=0; i<15; i++){
                this.$set(this.$data.searchResultData, i+artical_length, res.data.hits.hits[i])
              }
              this.startNum = this.startNum + 15
            }else{
              this.downloadMore = '暂无更多数据...'
            }
            this.loading = false;
          }, 1000);

          
          
        }).catch(error=>{
          console.log(error)
          console.log('请求失败')
        })
        
      }

      

    },
    //组件引入
    components: {

      Header,
      bbottom
    },
  }

</script>

<style scoped>
.tips_hot{
  display: inline-block;
  width:20px;
  height:20px;
  background: #3fba02;
  color: white;
  text-align: center;
  line-height: 20px;
  border-radius:5px;
}
.loading {
  animation: spin 1s linear infinite;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #db7134;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin: 20px auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.read-zhezhao i {
    display: block;
    width: 100%;
    height: 100%;
    background: rgb(252, 242, 238);
    opacity: 0.85;
    position: absolute;
    top: 0px;
    z-index: 100;
}
.read-zhezhao b {
    display: block;
    width: 50px;
    height: 16px;
    position: absolute;
    top: 10px;
    right: 20px;
    color: #cc0033;
    font-size: 14px;
    line-height: 20px;
    z-index: 1000;
    cursor: pointer;
}
.read-zhezhao {
    position: absolute;
    width:96%;
    height: 100%;
    display: block;
    top: 0px;
    left:18px;
    display: flex;
    align-items: center;
    color:#000;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
}
.read-zhezhao p{
  display: block;
  position: absolute;
  z-index: 1000;
  color:#818181;
  width:100%;
  
}
  .img {
    width: 100%;
    border-radius: 6px;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .content_s {
    width: 1200px;
    margin: 25px auto;
    color: #4b4b4b;
    min-height: 1300px !important;
  }

  .img_s {
    width: 100%;
    border-radius: 6px;
  }

  .top {
    width: 1200px;
    margin: 0 auto;
  }

    .top img {
      display: block
    }

  .all-search {
    position: fixed;
    top: 0;
    left: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    z-index: 1000;
    overflow: hidden;
  }

  .search-mask {
    width: 100%;
    height: 100%;
    background: #f1f1f1;
    opacity: 0.98;
    overflow: auto;
    transition: opacity 1s ease 0s;
  }

  .opacity0 {
    opacity: 0;
  }

  .opacity1 {
    opacity: 1;
  }

  .search-mask-contant {
    width: 1200px;
    margin: auto;
  }

  .search-mask-header {
    padding-top: 66px;
  }

  .logo {
    width: 223px;
    display: block;
    float: left;
    height: 52px;
  }

  .search-mask-header .close {
    width: 24px;
    height: 24px;
    float: right;
    position: relative;
    top: 20px;
    cursor: pointer;
  }

  .all-search-input1 {
    width: 892px;
    text-align: center;
    margin: 88px auto 60px;
  }
  .index_input1{
    width: 892px;
    text-align: center;
    margin: 0px auto 10px;
    position: absolute !important;
    z-index: 9999999 !important;
    margin-left:154px;
    top:160px;
  }

  .search-item, .listsearch-item {
    width: 880px;
    margin: 0px auto;
  }


  .all-search-input1 input {
    text-indent: 20px;
    height: 64px;
    width: 679px;
    font-size: 23px;
    color: #4b4b4b;
    letter-spacing: 0;
    text-align: left;
    border-radius: 8px;
    background: #fff;
    border-top: 2px solid #f1f1f1;
    border-left: 2px solid #f1f1f1;
    border-bottom: 2px solid #f1f1f1;
    border: 2px solid #f1f1f1;
    /* border-right: none; */
    display: inline-block;
    padding: 0px; 
    vertical-align: middle;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    margin-right:10px;
  }


.inp_s{
  border-bottom-right-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}

  .search_input_focus {
    text-indent: 20px;
    height: 64px;
    width: 679px;
    font-size: 36px;
    color: #4b4b4b;
    letter-spacing: 0;
    text-align: left;
    border-radius: 3px;
    background: #fff;
    outline: none;
    border-top: 2px solid #cc0033 !important;
    border-left: 2px solid #cc0033 !important;
    border-right: 2px solid #cc0033 !important;
    border-bottom: 2px solid #cc0033 !important;
    /* border: 2px solid #f1f1f1; */
    display: inline-block;
    padding: 0px; 
    vertical-align: middle;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    margin-right:10px;
  }


  .all-search-input1 input:focus{
    outline: none;
    border-top: 2px solid #cc0033 !important;
    border-left: 2px solid #cc0033 !important;
    border-right: 2px solid #cc0033 !important;
    border-bottom: 2px solid #cc0033 !important;
    /* border-bottom-right-radius: 8px; */
    /* border-bottom-left-radius: 8px; */
  }

  .input1_focus {
    /* border-bottom-width: 13px !important; */
    /* border-bottom-color: #4b4b4b !important; */
    /* border-bottom: 1px solid #4b4b4b !important; */
    outline: none;
    border-top: 2px solid #cc0033 !important;
    border-left: 2px solid #cc0033 !important;
    border-right: 2px solid #cc0033 !important;
    /* border-bottom: 2px solid #cc0033 !important; */
    border-bottom-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;



    /* border-bottom-left-radius: 0px; */
    /* border-bottom-right-radius: 0px; */
    /* border-bottom: 0;
    /* height: 64px;
    width: 679px;
    font-size: 36px;
    color: #4b4b4b;
    letter-spacing: 0;
    text-align: left;
    border-radius: 3px;
    background: #fff;
    /* border-color:#cc0033 !important; */
    /* border-top: 1px solid #f1f1f1;
    border-left: 1px solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
    border-right: none;
    display: inline-block;
    padding: 0px;
    vertical-align: middle; */
    /* border-top-right-radius: 0px; */
    /* border-bottom-right-radius: 0px; */
  }

  .listsearch {
    width: 880px;
    padding: 20px;
    margin: 0 auto;
    box-sizing: border-box;
  }

    .listsearch .el-tabs__item {
      font-size: 20px !important;
    }

  .el-icon-close:hover {
    transition: opacity 1s ease 0s;
  }

  .all-search-input1 .el-button--default {
    background-color: #cc0033;
    width: 198px;
    height: 66px;
    color: #ffffff;
    border: 1px solid #cc0033;
    font-size: 32px;
    margin-top: 0px;
    display: inline-block;
    vertical-align: middle;
    margin-left: -3px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

    .all-search-input1 .el-button--default:focus {
      /* border: 1px solid #ccc !important; */
    }

  .el-card {
    transition: 3s;
    margin: 0px 0px 30px 0px;
    height: 225px;
  }

  .video-pic {
    width: 261px;
    float: left;
    position: relative;
    height: 174px;
    overflow: hidden;
    margin-right: 20px;
  }

    .video-pic img {
      width:110%;
      display: block;
      float: left;
      transition: all 1s ease 0s;
      position: relative;
      left: -6px;
      top: -6px;
    }

    .video-pic .video-float {
      position: absolute;
      width: 50px;
      height: 50px;
      left: 105px;
      top: 62px;
    }

      .video-pic .video-float img {
        width: 60px;
        height: 60px;
      }

  .shake {
    width: 540px;
    float: left;
    position: relative;
    height: 174px;
  }

  .video-pic:hover .img {
    cursor: pointer;
    transform: scale(1.2);
  }

  .el-card h3 {
    margin: 0px;
    padding: 0px;
    font-size: 20px;
    line-height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    min-height: 48px;
  }

  .el-card p {
    font-size: 14px;
    line-height: 20px;
    margin: 0px;
    padding: 0px;
  }

  .el-card span {
    margin: 0px;
    padding: 0px;
    font-size: 12px;
    line-height: 18px;
    color: #999;
    display: block;
    position: absolute;
    left: 0px;
    bottom: 0px;
  }

  .shake em {
    font-weight: bold;
    font-style: normal;
    color: #cc0033;
  }

  .el-button--primary {
    background-color: #ffffff;
    border: 1px solid #f1f1f1;
    font-size: 18px;
    color: #999;
    display: block;
    margin: 35px auto;
  }

  .kx-search {
    width: 100%;
    padding: 25px;
    /* -webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); */
    /* box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); */
    border: 1px solid #f1f1f1;
    border-radius: 6px;
    margin: 10px auto;
    box-sizing: border-box;
    position: relative;
  }

   .kx-search:hover{
     border: 1px solid #cc0033;
     /* animation: mymove 0.5s infinite; */
    /* -webkit-animation: mymove 0.5s infinite; Safari and Chrome */
   }

   /* 动画边框循环 */

   @-webkit-keyframes mymove /*Safari and Chrome*/ 
   {
    from {
      border: 1px solid #379ffe;
      /* box-shadow: 0px 0px 7px 2px rgb(55 159 254 / 80%); */
      transform:scaleX(1);
      -webkit-transform:scaleX(1);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scaleX(1); 
    }
    to {
      border: 1px solid #090d14;
      transform:scaleX(0.95);
      -webkit-transform:scaleX(0.95);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scaleX(0.95); 
      /* box-shadow: 0px 1px 0px 0px rgba(9, 13, 20, 1); */
    }
}




    .kx-search h3 {
      margin: 0px;
      padding: 0px 0px 10px;
      font-size: 20px;
      line-height: 28px;
    }

    .kx-search h3 em{
      color: #cc0033;
    }

  .listsearch a {
    color: #4b4b4b;
    text-decoration: none;
  }

    /* .listsearch a:hover h3 {
      color: #cc0033;
    } */

  .kx-search p {
    font-size: 16px;
    line-height: 20px;
    margin: 0px;
    padding: 0px;
    display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 5;
overflow: hidden;
  }

  .kx-search span {
    margin: 0px;
    padding: 0px 0px 0px 0px;
    font-size: 12px;
    line-height: 18px;
    color: #999;
  }

  .kx-search >>> em {
    font-weight: bold;
    font-style: normal;
    color: #cc0033;
  }

  .listsearch-nodata {
    width: 830px;
    padding: 40px 25px;
    -webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    text-align: center;
    font-size: 16px;
    line-height: 24px;
  }




  /* 模仿百度搜索  */
 #box{
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* justify-content: center; */
 }
 .input{
  width: 500px;
  height: 30px;
  text-indent: 4px;
 }
 .baidu input{
  height: 30px;
  cursor: pointer;
  color: #fff;
  letter-spacing: 1px;
  background: #3385ff;
  border: 1px solid #2d78f4;
 }

 .index_input1 ul{
  display: block;
  background: #FFF;
  /* position: relative !important; */
  /* z-index: 9999 !important; */
   padding: 0;
   margin-top: -10px;
   /* border-radius: 3px; */
   border-bottom-right-radius: 8px;
   border-bottom-left-radius: 8px;
   width:679px;
   min-height:40px;
   /* border-top: 1px solid #f1f1f1; */
   border-left: 2px solid #cc0033;
   border-right: 2px solid #cc0033;
   border-bottom: 2px solid #cc0033;
   padding-bottom:30px;
   padding-top:15px;
 }

 li{
  list-style: none;
  cursor: pointer;
  text-align: left;
  padding-left: 10px;
 }

 /* li:hover{
  background: #f7ecee;
  color: #fa5d03;
 } */

 .li_hover{
  /* background: #f7ecee; */
  background: rgb(252, 242, 238);
  color: #fa5d03;
  
 }

 .bgcolor {
  background: #ccc;
 }
  
</style>



// WEBPACK FOOTER //
// src/components/Search.vue